import { buildClarityWorkspaceUrl } from './build-clarity-workspace-url.util';
import { toClaritySectionUrl } from './clarity-workspace-route.util';
import { CLARITY_DOCUMENTS_ROUTE_SEGMENT } from './constants/clarity-documents-route.constant';
import type { ClarityDocumentShareTarget } from './models/clarity-document-share-target.model';

export function buildClarityDocumentPath(target: ClarityDocumentShareTarget, sectionPath: string): string {
	const workspaceUrl = buildClarityWorkspaceUrl(
		{
			domainId: target.domainId,
			tab: CLARITY_DOCUMENTS_ROUTE_SEGMENT,
			doc: target.fileId,
			page: target.page,
			file: null,
			oi: null,
			action: null,
		},
		new URLSearchParams(),
	);

	return toClaritySectionUrl(sectionPath, workspaceUrl);
}
